import { render } from "./DnsRecordStats.vue?vue&type=template&id=0762b39e&scoped=true&lang=pug"
import script from "./DnsRecordStats.vue?vue&type=script&setup=true&lang=js"
export * from "./DnsRecordStats.vue?vue&type=script&setup=true&lang=js"

import "./DnsRecordStats.vue?vue&type=style&index=0&id=0762b39e&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0762b39e"]])

export default __exports__